import type {CourseAttrs} from '../models/course'

export function getUnarchivedModels(courses: Array<CourseAttrs>): Array<CourseAttrs> {
  return courses.filter(course => !course.archived)
}
